export default __webpack_public_path__ + "static/media/brain.1a7ade63.png";